import * as React from "react";
const SvgDropdownDown = props => <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" style={{
  enableBackground: "new 0 0 100 100"
}} viewBox="0 0 100 100" width="1em" height="1em" {...props}><path d="M50 60.7 12.2 25c-2.8-2.6-7.3-2.6-10.1 0s-2.8 6.9 0 9.5L44.9 75c2.8 2.6 7.3 2.6 10.1 0l42.9-40.5c2.8-2.6 2.8-6.9 0-9.5s-7.3-2.6-10.1 0L50 60.7z" className="dropdown-down_svg__st0" /></svg>;
export default SvgDropdownDown;